import { css, Global } from '@emotion/react';
import MilkywireHandRegularWoff from '../../../assets/fonts/MilkywireHand-Regular.woff';
import MilkywireHandRegularWoff2 from '../../../assets/fonts/MilkywireHand-Regular.woff2';
import SharpGroteskBook20Woff from '../../../assets/fonts/SharpGroteskBook20.woff';
import SharpGroteskBook20Woff2 from '../../../assets/fonts/SharpGroteskBook20.woff2';
import SharpGroteskBook25Woff from '../../../assets/fonts/SharpGroteskBook25.woff';
import SharpGroteskBook25Woff2 from '../../../assets/fonts/SharpGroteskBook25.woff2';
import SharpGroteskBookItalic20Woff from '../../../assets/fonts/SharpGroteskBookItalic20.woff';
import SharpGroteskBookItalic20Woff2 from '../../../assets/fonts/SharpGroteskBookItalic20.woff2';
import SharpGroteskMedium20Woff from '../../../assets/fonts/SharpGroteskMedium20.woff';
import SharpGroteskMedium20Woff2 from '../../../assets/fonts/SharpGroteskMedium20.woff2';
import SharpGroteskMedium25Woff from '../../../assets/fonts/SharpGroteskMedium25.woff';
import SharpGroteskMedium25Woff2 from '../../../assets/fonts/SharpGroteskMedium25.woff2';

/*
  Font weight scale (Sharp Grotesk):

  900 Black
  700 Bold
  600 SmBold
  500 Medium
  400 Book
  300 Light
  100 Thin
*/

const Fonts = () => (
  <Global
    styles={css`
      /* Width 20 */
      @font-face {
        font-family: 'Sharp-Grotesk';
        font-weight: 400;
        src: url('${SharpGroteskBook20Woff2}') format('woff2'),
          url('${SharpGroteskBook20Woff}') format('woff');
      }
      @font-face {
        font-family: 'Sharp-Grotesk';
        font-weight: 500;
        src: url('${SharpGroteskMedium20Woff2}') format('woff2'),
          url('${SharpGroteskMedium20Woff}') format('woff');
      }
      @font-face {
        font-family: 'Sharp-Grotesk';
        font-weight: 400;
        font-style: italic;
        src: url('${SharpGroteskBookItalic20Woff2}') format('woff2'),
          url('${SharpGroteskBookItalic20Woff}') format('woff');
      }

      /* Width 25 */
      @font-face {
        font-family: 'Sharp-Grotesk-Wide';
        font-weight: 500;
        src: url('${SharpGroteskMedium25Woff2}') format('woff2'),
          url('${SharpGroteskMedium25Woff}') format('woff');
      }
      @font-face {
        font-family: 'Sharp-Grotesk-Wide';
        font-weight: 400;
        src: url('${SharpGroteskBook25Woff2}') format('woff2'),
          url('${SharpGroteskBook25Woff}') format('woff');
      }

      /* MilkywireHand-Regular */
      @font-face {
        font-family: 'MilkywireHand-Regular';
        font-style: normal;
        font-weight: 400;
        src: url('${MilkywireHandRegularWoff2}') format('woff2'),
          url('${MilkywireHandRegularWoff}') format('woff');
      }
    `}
  />
);

export default Fonts;
